/**
 * Created by marlon.jerez on 10/07/2016.
 */
export class sideNavModel extends Backbone.Model {


	defaults() {
		return {}
	}


	urlRoot:"/sideNavModel";

	initialize(attributes?:any, options?:any) {

	}

}
